<template>
    <transition name="fade">
        <div class="toast">
            <div class="con">
                <div class="title flex jb ac">
                    <p class="flex ac"><img src="./img/icon_img50.png" alt=" " /><span>提示</span> </p>
                    <img src="./img/close.png" class="close" @click="close" alt=" " />
                </div>
                <div class="text">
                    该功能为会员专享功能，请升级会员后使用
                </div>
                <div class="open">
                    <span class="btn"  @click="open">开通会员</span>
                </div>
            </div>
        </div>
    </transition>
</template>
 
<script>
    export default {
        data() {
            return {
                theToast: false,
                msg: ""
            };
        },
        methods:{
            close () {
                this.theToast = false
                this.$store.commit('setToastVip', false)
            },
            open () {
                this.theToast = false
                this.$store.commit('setToastVip', false)
                this.$emit("vipOpenHandle")
            }
        }
    };
</script>
 
<style scoped>
    .toast {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        z-index: 19901;
        .con {
        position: absolute;
        background: #fff;
        padding: 15px 15px 27px;
        width: 418px;
        height: 166px;
        border-radius: 6px;
        z-index: 99;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .title {
            p {
                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 5px;
                }
                span {
                    font-size: 14px;
                    font-weight: bold;
                    color: #000;
                }
            }
            .close {
                width: 16px;
                height: 16px;
                cursor: pointer;
            }
        }
        .text {
            text-align: center;
            color: #333;
            font-size: 13px;
            padding: 25px 0;
        }
        .open {
            .btn {
                display: block;
                background: #4c83fc;
                border-radius: 4px;
                line-height: 32px;
                text-align: center;
                width: 116px;
                margin: 0 auto;
                color: #fff;
                text-align: center;
                cursor: pointer;
                &:hover {
                    opacity: 0.8;
                }
            }
        }
    }
}
</style>